import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { Check, X } from 'lucide-react';

const ImageCropperModal = ({ photo, onCropComplete, onCancel }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropChange = useCallback((crop) => {
    setCrop(crop);
  }, []);

  const onZoomChange = useCallback((zoom) => {
    setZoom(zoom);
  }, []);

  const onCropAreaChange = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleSave = () => {
    if (croppedAreaPixels) {
      onCropComplete(croppedAreaPixels);
    }
  };

  return (
    <div className="cropper-modal-overlay">
      <style>{`
        .cropper-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
        }
        .cropper-modal-content {
          background: #111113;
          padding: 24px;
          border-radius: 20px;
          width: 90%;
          max-width: 450px;
          border: 1px solid #333;
          box-shadow: 0 20px 40px rgba(0,0,0,0.4);
        }
        .cropper-container {
          position: relative;
          width: 100%;
          height: 350px;
          background: #000;
          border-radius: 12px;
          overflow: hidden;
        }
        .controls {
          padding: 24px 0;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .zoom-range {
          width: 100%;
          accent-color: #0060ff;
          height: 6px;
          background: #222;
          border-radius: 5px;
          outline: none;
        }
        .modal-actions {
          display: flex;
          gap: 12px;
        }
        .modal-btn {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px;
          border-radius: 10px;
          border: 1px solid transparent;
          cursor: pointer;
          font-weight: 600;
          transition: 0.2s;
          color: white;
        }
        .save-btn { background: #0060ff; }
        .save-btn:hover { background: #0056e0; }
        .cancel-btn { background: #222; border-color: #333; }
        .cancel-btn:hover { background: #333; }
        .control-label { color: #888; font-size: 0.85rem; text-align: center; }
      `}</style>

      <div className="cropper-modal-content">
        <div className="cropper-container">
          <Cropper
            image={photo}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={onCropChange}
            onZoomChange={onZoomChange}
            onCropComplete={onCropAreaChange}
            cropShape="round"
            showGrid={false}
          />
        </div>
        
        <div className="controls">
          <span className="control-label">Zoom to Fit</span>
          <input
            type="range"
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            onChange={(e) => onZoomChange(Number(e.target.value))}
            className="zoom-range"
          />
        </div>

        <div className="modal-actions">
          <button className="modal-btn cancel-btn" onClick={onCancel}>
            <X size={18} /> Cancel
          </button>
          <button className="modal-btn save-btn" onClick={handleSave}>
            <Check size={18} /> Apply Photo
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageCropperModal;